import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBucket"><Path d="M2 7.5V3H22V7.5H2Z" fill="currentColor"/><Path d="M3.58503 9L5.08808 21H18.9119L20.415 9H3.58503Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBucket;
